// extracted by mini-css-extract-plugin
module.exports = {"aircraft":"aircraft-1KE3b","image":"image-3KZzG","segmentFlat__totalDuration":"segmentFlat__totalDuration-1zyUb","title":"title-3VRDV"};